import { RadioGroup, useId } from '@fluentui/react-components';
import {
    DefaultStoreLocation,
    IStoreLocation,
    IStoreLocatorResultRadioGroupProps
} from './StoreLocator.types';
import StoreLocatorResultCard from './StoreLocatorResultCard';
import useStoreLocatorStyles from './StoreLocator.styles';
import { useEffect, useState } from 'react';
import { useCart } from '../../../contexts/CartContext/CartContext.hooks';

const StoreLocatorResultRadioGroup = (props: IStoreLocatorResultRadioGroupProps) => {
    const { results, groupName } = props;

    const [lastShownResultIdx, setLastShownResultIdx] = useState(3);

    const defaultDisplayedResults: IStoreLocation[] = [];

    const [displayedResults, setDisplayedResults] = useState(defaultDisplayedResults);

    const { cart, updateShippingMethod } = useCart();

    const styles = useStoreLocatorStyles();

    const [selectedStore, setSelectedStore] = useState(DefaultStoreLocation());

    const handleSelected = (storeName: string) => {
        const store = results.find((s) => s.name === storeName) ?? null;
        if (store != null) {
            setSelectedStore(store);
            const method = {
                ...cart.shippingMethod,
                address: store.address
            };
            updateShippingMethod(method);
        }
    };

    useEffect(() => {
        if (results[0]) handleSelected(results[0].name);
    }, [results]);

    useEffect(() => {
        setDisplayedResults(results.slice(0, lastShownResultIdx));
    }, [lastShownResultIdx]);

    const handleShowMore = () => {
        setLastShownResultIdx(lastShownResultIdx + 3);
    };

    const radioLabelId = useId('resultRadioGroup');

    return (
        <RadioGroup
            className={styles.resultGroup}
            aria-label={radioLabelId}
            name={groupName}
            key={'result'}
        >
            {displayedResults.map((r) => (
                <StoreLocatorResultCard
                    groupName={groupName}
                    result={r}
                    key={r.name}
                    selected={r.name === selectedStore.name}
                    onChange={handleSelected}
                />
            ))}

            {results.length > displayedResults.length && (
                <div
                    className={styles.showMoreButton}
                    onClick={handleShowMore}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === 'Space') handleShowMore();
                    }}
                >
                    Show More
                </div>
            )}
        </RadioGroup>
    );
};

export default StoreLocatorResultRadioGroup;
